module.exports = __webpack_public_path__ + "static/media/BA.698e3c48.png";